#import "../../../core-entity/graphql/fragments/tag-fragment.graphql"

fragment PeepTagMapsFragment on Peep {
    tagMaps(first: 1000) {
        edges {
            node {
                ...TagFragment
            }
        }
    }
}
